import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import { useState } from "react";

const useSignUp = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedState));

  // Input Vars
  const [signUpPhone, setSignUpPhone] = useState("");
  const [userName, setUserName] = useState("");
  const [signUpPass, setSignUpPass] = useState("");
  const [signUpConfirmPass, setSignUpConfirmPass] = useState("");

  // Eye
  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [eye, setEye] = useState(true);
  const [confirmEyeStyle, setConfirmEyeStyle] = useState(true);

  // Error Messages
  const [UserNameError, setUserNameError] = useState("user-name-error");
  const [PhoneNumberError, setPhoneNumberError] =
    useState("phone-number-error");
  const [PasswordError, setPasswordError] = useState("password-error");
  const [ConfirmPasswordError, setConfirmPasswordError] = useState(
    "confirm-password-error"
  );

  // Regular Expressions
  const regExpPhoneNumber = new RegExp(
    "^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$"
  ); //+919367788755
  const regExpUserName = new RegExp(
    "^(?=[a-zA-Z0-9._]{8,20}$)(?!.*[_.]{2})[^_.].*[^_.]$"
  ); //user name of 8-20 charachter

  const Eye = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      setEye(false);
    } else {
      setPasswordType("password");
      setEye(true);
    }
  };

  const ConfirmEye = () => {
    if (confirmPasswordType === "password") {
      setConfirmPasswordType("text");
      setConfirmEyeStyle(false);
    } else {
      setConfirmPasswordType("password");
      setConfirmEyeStyle(true);
    }
  };

  const onChangeInput = (event, inputID) => {
    document.getElementById(inputID).classList.remove("is-invalid");
    if (inputID === "signup-user-name") {
      setUserName(event.target.value);
    } else if (inputID === "signup-phone") {
      setSignUpPhone(event.target.value);
    } else if (inputID === "signup-pass") {
      setSignUpPass(event.target.value);
    } else if (inputID === "signup-confirm-pass") {
      setSignUpConfirmPass(event.target.value);
    }
  };

  const checkInput = () => {
    if (
      userName === "" ||
      signUpPhone === "" ||
      signUpPass === "" ||
      signUpConfirmPass === ""
    ) {
      if (userName === "") {
        setUserNameError("user-name-error");
        document.getElementById("signup-user-name").classList.add("is-invalid");
      }
      if (signUpPhone === "") {
        setPhoneNumberError("phone-number-error");
        document.getElementById("signup-phone").classList.add("is-invalid");
      }
      if (signUpPass === "") {
        setPasswordError("password-error");
        document.getElementById("signup-pass").classList.add("is-invalid");
      }
      if (signUpConfirmPass === "") {
        setConfirmPasswordError("confirm-password-error");
        document
          .getElementById("signup-confirm-pass")
          .classList.add("is-invalid");
      }
    } else if (
      signUpPass !== signUpConfirmPass ||
      !regExpPhoneNumber.test(signUpPhone) ||
      !regExpUserName.test(userName)
    ) {
      if (signUpPass !== signUpConfirmPass) {
        setConfirmPasswordError("confirm-password-input-error");
        document
          .getElementById("signup-confirm-pass")
          .classList.add("is-invalid");
      }
      if (!regExpPhoneNumber.test(signUpPhone)) {
        setPhoneNumberError("phone-number-input-error");
        document.getElementById("signup-phone").classList.add("is-invalid");
      }
      if (!regExpUserName.test(userName)) {
        setUserNameError("user-name-input-error");
        document.getElementById("signup-user-name").classList.add("is-invalid");
      }
    } else toConfirmCode();
  };

  const toConfirmCode = () => {
    document
      .querySelector(".ConfirmCode")
      .classList.toggle("current-section-start");
    document
      .querySelector(".copy-rights-section")
      .classList.toggle("current-section-start");
    document.querySelector(".Signup").classList.remove("current-section-start");
  };
  const backToLogIn = () => {
    document.querySelector(".Login").classList.toggle("current-section-start");
    document
      .querySelector(".copy-rights-section")
      .classList.remove("current-section-start");
    document.querySelector(".Signup").classList.remove("current-section-start");
  };

  return {
    locale,
    eye,
    confirmEyeStyle,
    UserNameError,
    PhoneNumberError,
    PasswordError,
    ConfirmPasswordError,
    passwordType,
    confirmPasswordType,
    Eye,
    ConfirmEye,
    onChangeInput,
    checkInput,
    backToLogIn,
  };
};

export default useSignUp;
